__turbopack_context__.v({
  "backgroundColor": "a4zFGa_backgroundColor",
  "defaqtoBg": "a4zFGa_defaqtoBg",
});
